import React, { useState, useEffect, createContext, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const initialGlobalContext = {
  keyword: '',
  setKeyword: () => '',
  mainColor: '',
  setMainColor: () => '',
  modalRootRef: null,
  isWL: false,
  setIsWL: () => false,
  isBusinessMode: false,
  setIsBusinessMode: () => false,
};

type GlobalContextType = {
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  mainColor: string | null;
  setMainColor: React.Dispatch<React.SetStateAction<string | null>>;
  modalRootRef: any;
  isWL: boolean;
  setIsWL: React.Dispatch<React.SetStateAction<boolean>>;
  isBusinessMode: boolean;
  setIsBusinessMode: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalContext = createContext<GlobalContextType>(initialGlobalContext);

export const GlobalProvider = ({ children }: any) => {
  const [keyword, setKeyword] = useState('');
  const [isWL, setIsWL] = useState(false);
  const [isBusinessMode, setIsBusinessMode] = useState(false);
  const [mainColor, setMainColor] = useState<string | null>(null);
  const modalRootRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  // const resultPages = [
  //   '/all',
  //   '/results/market',
  //   '/results/square',
  //   '/results/community',
  //   '/search',
  //   '/properties',
  // ];

  // const resultPages = ['/', '/square', '/community'];

  const value = {
    keyword,
    setKeyword,
    modalRootRef,
    isWL,
    setIsWL,
    mainColor,
    setMainColor,
    isBusinessMode,
    setIsBusinessMode,
  };

  useEffect(() => {
    const pathname = location.pathname;

    // Check if the current path is a result page and reset the search keyword
    // if (!resultPages.includes(location.pathname)) {
    if (pathname === '/' || pathname === '/square' || pathname === '/community') {
      setKeyword('');
    }

    // Define the routes that should enable isBusinessMode
    const businessRoutes = [
      '/business-dashboard/settings',
      '/business-dashboard/manage-listings',
      '/business-dashboard/dashboard',
      '/business-dashboard/profile',
      '/business-dashboard/billing-payment',
      '/create-property/business',
      '/property-created/business',
      '/hunting-board/leadsubmitted/business',
      '/hunting-board/huntcreated/business',
      '/hunting-board/dashboard/business',
      '/hunting-board/matches/hunt/business',
      '/hunting-board/leads/hunt/business',
      '/hunting-board/create-hunt/business',
    ];
    const isBusiness = businessRoutes.some((route) => pathname.startsWith(route));
    if (isBusiness) {
      setIsBusinessMode(isBusiness);
    }
  }, [location, setKeyword]);

  return <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>;
};

export function useGlobal() {
  const context = useContext(GlobalContext);

  return context;
}
